export enum LetterStateEnum {
    empty_text = 0,
    "text_1/3" = 1,
    "text_2/3" = 2,
    full_text = 3
}

export class LetterModel {
    public visible: boolean = false
    public state: LetterStateEnum = LetterStateEnum.empty_text;

    constructor() {
    }
}
